/** angular */
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
/** end angular */

/** sixense */
import { DsUserService } from '@sixense/ds-roazhon-service';
import { DsLibLanguageService } from '@sixense/ds-lib-common';
import { first } from 'rxjs/internal/operators/first';
import { BydUserAccount } from '@sixense/byd-auth-service';
/** end sixense */

@Component({
  selector: 'ds-user-account',
  templateUrl: './ds-user-account.component.html',
  styleUrls: ['./ds-user-account.component.scss'],
})
export class DsUserAccountComponent {
  /**
   * The current account
   */
  public account: BydUserAccount;

  /**
   * The support email
   */
  public supportEmail = 'digital@sixense-group.com';

  /**
   * Double-way binding for language.
   */
  public currentLanguage: string;

  /**
   * Creates an instance of DsUserAccountComponent.
   *
   * @param activatedRoute The activatedRoute service
   * @param translate The translate service
   * @param languageService The language service
   * @param userService The user service
   */
  constructor(
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private languageService: DsLibLanguageService,
    private userService: DsUserService
  ) {
    this.account = this.activatedRoute.snapshot.data.BydUserResolver;
    this.currentLanguage = this.languageService.getCurrentLang();
  }

  /**
   * Changes the current language.
   *
   * @param language The language to set
   */
  public onLanguageChange(language: string) {
    this.languageService.use(language);
    this.languageService.setPickedLanguage(language);
    this.translate.use(this.currentLanguage);
    this.userService.patchLanguage(this.account.account_id, language).pipe(first()).subscribe();
  }
}
